import { track } from 'ripple';

export component AuthPage(props) {
	let isSignIn = track(true);
	let email = track('');
	let password = track('');
	let confirmPassword = track('');
	let username = track('');
	let onBack = props.onBack;
	let onDashboard = props.onDashboard;

	<div class="auth-container">
		<div class="auth-card">
			<div class="auth-header">
				if (@isSignIn) {
					<h2>{"Sign In"}</h2>
					<p>{"Access your secure cross-chain trading account"}</p>
				} else {
					<h2>{"Register"}</h2>
					<p>{"Create your secure trading account"}</p>
				}
			</div>

			<form class="auth-form" onSubmit={(e) => {
				e.preventDefault();
				// Handle form submission
				if (@isSignIn) {
					// Sign in logic would go here
					console.log('Signing in with:', @email, @password);
					@onDashboard(); // Navigate to dashboard after successful login
				} else {
					// Register logic would go here
					console.log('Registering with:', @email, @password, @username);
					@onDashboard(); // Navigate to dashboard after successful registration
				}
			}}>
				if (!@isSignIn) {
					<div class="form-group">
						<label for="username">{"Username"}</label>
						<input
							type="text"
							id="username"
							value={@username}
							placeholder="Enter your username"
							class="form-input"
						/>
					</div>
				}

				<div class="form-group">
					<label for="email">{"Email Address"}</label>
					<input
						type="email"
						id="email"
						value={@email}
						placeholder="Enter your email"
						class="form-input"
						required
					/>
				</div>

				<div class="form-group">
					<label for="password">{"Password"}</label>
					<input
						type="password"
						id="password"
						value={@password}
						placeholder="Enter your password"
						class="form-input"
						required
						minlength="8"
					/>
				</div>

				if (!@isSignIn) {
					<div class="form-group">
						<label for="confirmPassword">{"Confirm Password"}</label>
						<input
							type="password"
							id="confirmPassword"
							value={@confirmPassword}
							placeholder="Confirm your password"
							class="form-input"
							required
						/>
					</div>
				}

				if (@isSignIn) {
					<div class="form-group">
						<div class="checkbox-group">
							<input type="checkbox" id="remember" />
							<label for="remember">{"Remember me"}</label>
						</div>
					</div>
				}

				if (@isSignIn) {
					<button type="submit" class="btn btn-primary btn-full">{"Sign In"}</button>
				} else {
					<button type="submit" class="btn btn-primary btn-full">{"Register"}</button>
				}
			</form>

			<div class="auth-footer">
				<button class="btn-link" onClick={() => @onBack()}>
					{"← Back to Home"}
				</button>
				if (@isSignIn) {
					<p>
						{"Don't have an account?"}
						<button class="btn-link" onClick={() => @isSignIn = false}>
							{"Register"}
						</button>
					</p>
				} else {
					<p>
						{"Already have an account?"}
						<button class="btn-link" onClick={() => @isSignIn = true}>
							{"Sign In"}
						</button>
					</p>
				}
			</div>

			if (@isSignIn) {
				<div class="auth-options">
					<button class="btn btn-secondary btn-full">
						{"Continue with Google"}
					</button>
					<button class="btn btn-secondary btn-full">
						{"Continue with MetaMask"}
					</button>
				</div>
			}
		</div>
	</div>

	<style>
		.auth-container {
			min-height: 100vh;
			display: flex;
			align-items: center;
			justify-content: center;
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			padding: 1rem;
		}

		.auth-card {
			background: white;
			padding: 2.5rem;
			border-radius: 1rem;
			box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
			width: 100%;
			max-width: 400px;
		}

		.auth-header {
			text-align: center;
			margin-bottom: 2rem;
		}

		.auth-header h2 {
			color: #1f2937;
			font-size: 1.75rem;
			font-weight: bold;
			margin-bottom: 0.5rem;
		}

		.auth-header p {
			color: #6b7280;
			font-size: 0.9rem;
		}

		.auth-form {
			margin-bottom: 1.5rem;
		}

		.form-group {
			margin-bottom: 1.5rem;
		}

		.form-group label {
			display: block;
			color: #374151;
			font-weight: 500;
			margin-bottom: 0.5rem;
		}

		.form-input {
			width: 100%;
			padding: 0.75rem;
			border: 1px solid #d1d5db;
			border-radius: 0.5rem;
			font-size: 1rem;
			transition: border-color 0.3s ease;
		}

		.form-input:focus {
			outline: none;
			border-color: #4f46e5;
			box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
		}

		.checkbox-group {
			display: flex;
			align-items: center;
			gap: 0.5rem;
		}

		.checkbox-group input[type="checkbox"] {
			margin: 0;
		}

		.btn {
			padding: 0.75rem 1rem;
			border: none;
			border-radius: 0.5rem;
			cursor: pointer;
			font-size: 1rem;
			transition: all 0.3s ease;
			text-align: center;
		}

		.btn-primary {
			background: #4f46e5;
			color: white;
			width: 100%;
		}

		.btn-primary:hover {
			background: #4338ca;
		}

		.btn-secondary {
			background: #f3f4f6;
			color: #374151;
			width: 100%;
			margin-bottom: 0.5rem;
		}

		.btn-secondary:hover {
			background: #e5e7eb;
		}

		.btn-full {
			width: 100%;
		}

		.btn-link {
			background: none;
			color: #4f46e5;
			text-decoration: underline;
			border: none;
			cursor: pointer;
			padding: 0;
			font-size: 1rem;
		}

		.btn-link:hover {
			color: #4338ca;
		}

		.auth-footer {
			text-align: center;
			margin-bottom: 1.5rem;
		}

		.auth-footer p {
			color: #6b7280;
			font-size: 0.9rem;
		}

		.auth-options {
			border-top: 1px solid #e5e7eb;
			padding-top: 1.5rem;
		}

		.auth-options .btn {
			margin-bottom: 0.5rem;
		}
	</style>
}